<template>
  <div class="btn-group">
    <button type="button"
            class="btn btn-white"
            :disabled="value === 1"
            @click="switchCurrentPage(value - 1)"><i class="fa fa-chevron-left"></i></button>
    <div v-if="currentPageHigherThanFour"
         class="btn btn-white etc">...</div>
    <button v-for="pageCount in dotsPagination"
            :key="pageCount"
            class="btn btn-white"
            :class="{'active': pageCount === value}"
            @click="switchCurrentPage(pageCount)">{{ pageCount }}</button>
    <div v-if="currentPageLowerThanMax"
         class="btn btn-white etc">...</div>
    <button type="button"
            class="btn btn-white"
            :disabled="value === totalPages"
            @click="switchCurrentPage(value + 1)"><i class="fa fa-chevron-right"></i></button>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: Number,
        required: true
      },
      totalPages: {
        type: Number,
        required: false,
        default: 0
      }
    },

    data: () => ({
      pages: []
    }),

    computed: {
      currentPageHigherThanFour () {
        return this.value > 4
      },

      currentPageLowerThanMax () {
        return this.value < this.totalPages - 4
      },

      dotsPagination () {
        let pagination = []
        for (let i = 1; i <= this.totalPages; i++) {
          pagination.push(i)
        }

        return pagination.slice(Math.max(0, this.value - 4), Math.min(this.totalPages, this.value + 3))
      },

    },

    mounted () {
      for (let i = 0; i < this.totalPages; i++) {
        this.pages.push(i + 1)
      }
    },

    methods: {
      switchCurrentPage (pageCount) {
        this.$emit('input', pageCount)
      }
    }
  }
</script>

<style>
  .etc {
    pointer-events: none;
    cursor: default;
  }
</style>